import axios from 'axios';
import { currentSubdomain } from '../lib/tenant';
import { QURILMA_SESSIYA } from '../lib/qurilma';

const API_URL = import.meta.env.VITE_API_URL || 'https://sata.up.railway.app';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

/* "Yangilash" tugmasi bosilgandan keyingi qisqa oyna: shu vaqt ichidagi so'rovlar
   `X-Refresh: 1` bilan ketadi va server o'z keshini (masalan dashboard, 30s)
   chetlab o'tadi — aks holda tugma bosilsa ham eski raqam qaytishi mumkin edi. */
let yangilashGacha = 0;
export function markRefresh(ms = 5000) {
  yangilashGacha = Date.now() + ms;
}

// Har bir so'rovga tokenni + (bor bo'lsa) tenant subdomenini qo'shish
api.interceptors.request.use((config) => {
  if (Date.now() < yangilashGacha) config.headers['X-Refresh'] = '1';
  const token = localStorage.getItem('sata_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // "Panel faqat ilova": SATA ilovasi ochgan panel sessiyasi (spec 2026-10-15 §8.3)
  const qurilma = localStorage.getItem(QURILMA_SESSIYA);
  if (qurilma) config.headers['X-Qurilma'] = qurilma;
  const sub = currentSubdomain();
  if (sub) config.headers['X-Tenant-Slug'] = sub; // SaaS: hozircha ma'lumot, majburiy emas
  return config;
});

// 401 (token yaroqsiz) yoki SaaS 403 (maktab faol emas / subdomen mos emas) da
// sessiyani tozalab, login sahifasiga qaytaramiz.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const data = error.response?.data as { tenantInactive?: boolean; tenantMismatch?: boolean; qurilmaBloklangan?: boolean } | undefined;
    const tenantKick = status === 403 && (data?.tenantInactive || data?.tenantMismatch);
    if (status === 401 || tenantKick) {
      // KIOSK (TV) — ochiq sahifa, sessiyasiz ishlaydi: uni hech qachon /login ga
      // otib yubormaymiz va localStorage'ini tozalamaymiz (ekran o'chib qolmasin).
      // `/ilova` — qurilma sessiyasi almashmoqda: eski sessiya bilan ketgan so'rovning kechikkan
      // 401 i yangi sessiyani va tokenni o'chirmasin; natijani `Ilova.tsx` o'zi hal qiladi.
      const yol = window.location.pathname;
      if (yol.startsWith('/kiosk') || yol.startsWith('/ilova')) return Promise.reject(error);
      localStorage.removeItem('sata_token');
      localStorage.removeItem('sata_user');
      // Qurilma bloklangan/rad etilgan — panel sessiyasi ham o'lik: keyingi kirish faqat ilova qayta ochganda
      if (data?.qurilmaBloklangan) localStorage.removeItem(QURILMA_SESSIYA);
      if (!location.pathname.startsWith('/login')) location.href = '/login';
    }
    return Promise.reject(error);
  }
);

/** Bucket'dagi fayl (masalan avatar) uchun to'liq URL — backend stream endpointi orqali.
 *  <img> teglari header yubora olmagani uchun token query'da beriladi. */
export function fileUrl(key?: string | null): string | undefined {
  // Stiker avatarlar (sticker:<emoji>) fayl emas — img so'rovi yuborilmasin
  if (!key || key.startsWith('sticker:')) return undefined;
  const token = localStorage.getItem('sata_token') || '';
  return `${API_URL}/uploads/file/${key}?token=${encodeURIComponent(token)}`;
}

export default api;
